// extracted by mini-css-extract-plugin
export default {"AppMainBar":"AppMainBar_AppMainBar__bB1z1","bg":"AppMainBar_bg__LIRKE"};